import React, { useRef } from 'react'
import theme from 'stories/utils/theme'
import { Headline2, Headline3, Subtitle1 } from 'stories/elements/Typography/Text'
import useMedia from 'lib/hooks/useMedia'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import { ComponentContainer } from 'components/layouts/Layouts.css'
import _useTranslation from 'lib/hooks/_useTranslation'
import { getReferrerScreen } from 'lib/formatting/url'
import { useRouter } from 'next/router'
import DownloadBenefit from 'assets/pro-plan/download_benefit.webp'
import ContentBenefit from 'assets/pro-plan/content_benefit.webp'
import AdsBenefit from 'assets/pro-plan/ads_beenfit.webp'
import BenefitCarousel from 'components/modules/Carousel/BenefitCarousel'
import { AnalyticsEventProPlanSectionImpression } from 'lib/constants/AnalyticsEventType'
import useImpressionTracking from 'lib/hooks/useImpressionTracking'

interface Props {
    onGetPlusPlanButtonClick: (value: string) => void
}

const VariantPlusPlanBenefits = ({ onGetPlusPlanButtonClick }: Props) => {
    const { t } = _useTranslation('plusPlan')
    const md = useMedia(deviceSize.md)
    const router = useRouter()
    const referrerScreen = getReferrerScreen(router)

    const bannerRef = useRef<HTMLDivElement>(null)

    useImpressionTracking(bannerRef, AnalyticsEventProPlanSectionImpression, { referrerScreen, value: 'benefits' })

    const benefits = [
        {
            title: t('plusPlan/benefitCarouselTitle1'),
            text: t('plusPlan/benefitCarouselText1'),
            image: DownloadBenefit,
            eventValue: 'download',
        },
        {
            title: t('plusPlan/benefitCarouselTitle2'),
            text: t('plusPlan/benefitCarouselText2'),
            image: ContentBenefit,
            eventValue: 'topKnow',
        },
        {
            title: t('plusPlan/benefitCarouselTitle3'),
            text: t('plusPlan/benefitCarouselText3'),
            image: AdsBenefit,
            eventValue: 'noAds',
        },
    ]

    const Headline = md ? Headline3 : Headline2

    return (
        <ComponentContainer color={theme.colors.transparent}>
            <section ref={bannerRef}>
                <Subtitle1
                    color={theme.colors.white}
                    textAlign="center"
                    marginBottom={10}
                    fontWeight={400}
                    fontFamily="var(--font-inter)"
                >
                    {t('plusPlan/packageBenefitTitle')}
                </Subtitle1>
                <Headline color={theme.colors.white} textAlign="center" marginBottom={50} fontWeight={700}>
                    {t('plusPlan/packageBenefitSubtitle')}
                </Headline>
                <BenefitCarousel
                    carouselData={benefits}
                    onButtonClick={(value: string) => onGetPlusPlanButtonClick(value)}
                    referrerScreen={referrerScreen}
                />
            </section>
        </ComponentContainer>
    )
}

export default VariantPlusPlanBenefits
